<template>
  <v-container fluid grid-list-md>
    <page-title :title="$t('comefare.title')"></page-title>
    <v-layout row wrap>
      <v-flex
        xs10
        sm8
        lg6
        offset-xs1
        offset-sm2
        offset-lg3
        class="mt-3 mx-1 px-1 wrapper-flex"
      >
        <div class="fit-content">
          <v-layout row wrap>
            <v-flex sm12 md6 lg6 v-for="card in filteredHowtolist" :key="card.id">
              <v-card
                ripple
                class="flexcard"
                :href="card.redirect"
                target="_blank"
              >
                <v-responsive class="flex-val">
                  <cloudinary-image
                    :id="card.cover"
                    type="image"
                    transformation="w_600,h_300,c_fill,q_auto,f_jpg,g_faces:center"
                  />
                </v-responsive>
                <v-tooltip top>
                  <v-card-title primary-title class="grow pt-3" slot="activator">
                    <div class="tronchetto">
                      <span class="subheading font-weight-black mb-0">{{ card.title }}</span>
                    </div>
                  </v-card-title>
                  {{ card.title }}
                </v-tooltip>
                <!-- Comandi solo per Amministratori -->
                <v-card-actions v-if="isAdmin" class="pt-0 expand-height no-pointer">
                  <v-btn color="primary" @click.prevent="openEdit(card)">Modifica </v-btn>
                  <v-btn
                    flat
                    @click.prevent="deleteElement(card)"
                    :class="
                      isDrin
                        ? 'bold-text secondary--text ml-2'
                        : 'indigo--text text--darken-2 bold-text ml-2'
                    "
                  >
                    Elimina
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-flex>
          </v-layout>
        </div>
      </v-flex>
    </v-layout>
    <!-- Bottone volante per aggiunta -->
    <v-tooltip v-if="isAdmin" left>
      <v-btn
        style="z-index: 20"
        @click="showUploader = true"
        slot="activator"
        color="error"
        fab
        fixed
        right
        bottom
      >
        <v-icon>add</v-icon>
      </v-btn>
      <span>{{ $t('media.aggiungi') }}</span>
    </v-tooltip>
    <!-- Modale per inserimento nuova istruzione -->
    <v-dialog v-model="showUploader" persistent max-width="500">
      <v-card>
        <v-card-title class="headline">
          <span>Aggiungi una card istruttiva</span>
        </v-card-title>
        <v-card-text>
          <div>
            <v-text-field v-model="title" label="Titolo"></v-text-field>
          </div>
          <h3>Copertina</h3>
          <span class="d-flex align-center">
            <v-btn color="primary" @click="lfMedia(1)">Seleziona media</v-btn>
            oppure
            <v-text-field
              class="ml-2"
              v-model="mediaLinkCopertina"
              label="Inserisci il link"
            ></v-text-field>
          </span>
          <h3>URL Reindirizzamento</h3>
          <span class="d-flex align-center">
            <v-btn color="primary" @click="lfMedia(2)">Seleziona media</v-btn>
            oppure
            <v-text-field
              class="ml-2"
              v-model="mediaLinkRedirect"
              label="Inserisci il link"
            ></v-text-field>
          </span>
          <v-radio-group v-model="radioGroup">
            <v-radio label="Italiano" value="it"></v-radio>
            <v-radio label="Inglese" value="en"></v-radio>
          </v-radio-group>
          <div>
            <v-select :items="themes" label="Tema" v-model="theme"></v-select>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn flat @click.native="addHowTo">
            <span>Aggiungi</span>
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn flat @click.native="showUploader = false">
            <span>Annulla</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Modale per modifica elemento -->
    <v-dialog v-model="showEdit" persistent max-width="500">
      <v-card>
        <v-card-title class="headline">
          <span>Modifica card istruttiva</span>
        </v-card-title>
        <v-card-text>
          <div>
            <v-text-field v-model="title" label="Titolo"></v-text-field>
          </div>
          <h3>Copertina</h3>
          <span class="d-flex align-center">
            <v-btn color="primary" @click="lfMedia(1)">Seleziona media</v-btn>
            oppure
            <v-text-field
              class="ml-2"
              v-model="mediaLinkCopertina"
              label="Inserisci il link"
            ></v-text-field>
          </span>
          <h3>URL Reindirizzamento</h3>
          <span class="d-flex align-center">
            <v-btn color="primary" @click="lfMedia(2)">Seleziona media</v-btn>
            oppure
            <v-text-field
              class="ml-2"
              v-model="mediaLinkRedirect"
              label="Inserisci il link"
            ></v-text-field>
          </span>
          <v-radio-group v-model="radioGroup">
            <v-radio label="Italiano" value="it"></v-radio>
            <v-radio label="Inglese" value="en"></v-radio>
          </v-radio-group>
          <div>
            <v-select :items="themes" label="Tema" v-model="theme"></v-select>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn flat @click.native="editHowTo">
            <span>Modifica</span>
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn flat @click.native="showEdit = false">
            <span>Annulla</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Modale per eliminazione dell'elemento -->
    <v-dialog v-model="showDelete" persistent max-width="500">
      <v-card>
        <v-card-title class="headline">
          <span>Sei sicuro di eliminare la card?</span>
        </v-card-title>
        <v-card-actions>
          <v-btn flat @click.native="deleteHowTo">
            <span>Elimina</span>
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn flat @click.native="showDelete = false">
            <span>Annulla</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Modale per selezione media -->
    <!-- browse dialog -->
    <v-dialog v-model="browseDialog" max-width="800" scrollable @keydown.prevent.enter="search">
      <v-card>
        <v-toolbar class="title grey lighten-2" flat>
          <v-toolbar-title> Inserisci media esistenti </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="closeBrowser">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text style="height: 800px">
          <!-- ricerca -->
          <v-container fluid grid-list-lg>
            <v-form>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-text-field
                    v-model="q"
                    clearable
                    clear-icon="undo"
                    label="Cerca..."
                    type="text"
                    @input="search"
                  />
                </v-flex>
              </v-layout>
            </v-form>
            <v-layout row wrap>
              <v-flex v-for="(m, index) in mediaList" :key="index" xs12 sm6 md4>
                <search-media-card
                  :media="m"
                  :selected="isSelected(m)"
                  @media:selected="mediaSelected"
                />
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex class="mt-1" xs12 column justify-center>
                <v-btn
                  @click="loadMore()"
                  outline
                  class="ml-0 mt-4"
                  color="secondary"
                  v-if="total > mediaList.length"
                  ><v-icon small>add</v-icon> Mostra di più</v-btn
                >
                <v-alert
                  :value="mediaList.length && mediaList.length < total"
                  color="info"
                  icon="info"
                  outline
                  class="mt-4"
                >
                  Caricati tutti i media, {{ total }} in totale
                </v-alert>
                <v-alert :value="!mediaList.length" color="info" icon="info" outline>
                  Nessun media trovato
                </v-alert>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-divider />
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import cloudinaryImage from '@/components/common/CloudinaryImage';
import { $cloudinaryUrl } from '@/mixins/cloudinary';
import { $EventBus } from '@/eventBus';
import _union from 'lodash/union';
import _debounce from 'lodash/debounce';
import searchMediaCard from '@/components/media/SearchMediaCard';
import pageTitle from '@/components/common/PageTitle';

export default {
  data: () => ({
    tenantsId: [],
    tenantsNames: [],
    showUploader: false,
    title: '',
    theme: '',
    mediaLinkCopertina: '',
    mediaLinkRedirect: '',
    radioGroup: 'it',
    howtolist: [],
    themes: ['manifest', 'drin', 'musei'],
    isDrin: false,
    showEdit: false,
    showDelete: false,
    itemId: null,
    browseDialog: false,
    referencedMedia: [],
    add: false,
    mediaList: [],
    selected: [],
    total: null,
    valid: true,
    perPage: 18,
    page: 1,
    limit: 10,
    q: null, // chiave di ricerca
    flag: null,
  }),
  components: {
    cloudinaryImage,
    searchMediaCard,
    pageTitle,
  },
  mixins: [$cloudinaryUrl],
  methods: {
    lfMedia(value) {
      this.browseDialog = true;
      this.flag = value;
      this.getMedia();
    },
    search: _debounce(function (val) {
      this.page = 1;
      this.getMedia();
    }, 500),
    getMedia(loadMore) {
      return new Promise((resolve, reject) => {
        const searchData = this.q ? [this.q] : null;
        const params =
          {
            q: searchData,
            page: this.page,
            limit: this.limit,
          } || {};
        // if (this.type.includes('pdf')) {
        //   params.format = 'pdf'; // sottoinsieme delle immagini
        // }
        // this.resourceType.forEach((t) => {
        //   params[`resource_${t}`] = 1;
        // });
        this.$http({
          method: 'GET',
          url: '/media/',
          params: params,
        })
          .then((response) => {
            this.total = response.data.total;
            if (!loadMore) {
              this.mediaList = response.data.items; // lista
            } else {
              this.mediaList = _union(this.mediaList, response.data.items); // appendi
            }
            resolve();
          })
          .catch((err) => {
            reject(err);
            $EventBus.$emit('message', { type: 'error', text: 'Impossibile recuperare i media' });
          });
      });
    },
    loadMore() {
      this.page += 1;
      this.getMedia(true);
    },
    isSelected(media) {
      return this.selected.findIndex((m) => m.public_id === media.public_id) !== -1;
    },
    openEdit(element) {
      this.assignValues(element);
      this.showEdit = true;
    },
    deleteElement(element) {
      this.assignValues(element);
      this.showDelete = true;
    },
    assignValues(element) {
      this.itemId = element.id;
      this.title = element.title;
      this.theme = element.theme;
      this.mediaLinkRedirect = element.redirect;
      this.mediaLinkCopertina = element.cover;
      this.radioGroup = element.lang;
    },
    mediaSelected(mediaSelected) {
      this.selected = [mediaSelected]; // sempre uno solo
    },
    getTenant(id) {
      this.$http({
        method: 'GET',
        url: '/tenants/' + id,
      })
        .then((response) => {
          let name = response.data.i18n_name;
          let id = response.data.business_id;
          this.tenantsNames.push(name);
          this.tenantsId.push(id);
        })
        .catch((err) => {
          console.log('media get error', err);
          $EventBus.$emit('message', { type: 'error', text: 'Impossibile recuperare i tenants' });
        });
    },
    getHowTo() {
      this.$http({
        method: 'GET',
        url: '/howtolist/',
      })
        .then((response) => {
          this.howtolist = response.data;
        })
        .catch((err) => {
          console.log('media get error', err);
          $EventBus.$emit('message', { type: 'error', text: 'Impossibile recuperare i media' });
        });
    },
    editHowTo() {
      this.showEdit = false;
      this.$http({
        method: 'PATCH',
        url: `/howtolist/${this.itemId}`,
        data: {
          title: this.title,
          cover: this.mediaLinkCopertina,
          redirect: this.mediaLinkRedirect,
          lang: this.radioGroup,
          theme: this.theme,
        },
      })
        .then((response) => {
          this.$router.go();
          $EventBus.$emit('message', { type: 'success', text: "Dati dell'elemento aggiornati" });
        })
        .catch((err) => {
          console.log("errore nell'aggiornamento dei dati", err);
          $EventBus.$emit('message', {
            type: 'error',
            text: "Impossibile aggiornare i dati dell'elemento",
          });
        });
    },
    deleteHowTo() {
      this.showEdit = false;
      this.$http({
        method: 'DELETE',
        url: `/howtolist/${this.itemId}`,
      })
        .then((response) => {
          this.$router.go();
          $EventBus.$emit('message', { type: 'success', text: 'Elemento eliminato con successo' });
        })
        .catch((err) => {
          console.log("errore nell'eliminazione dell'elemento", err);
          $EventBus.$emit('message', {
            type: 'error',
            text: "Impossibile eliminare l'elemento",
          });
        });
    },
    addHowTo() {
      this.showUploader = false;
      this.$http({
        method: 'POST',
        url: '/howtolist/',
        data: {
          title: this.title,
          cover: this.mediaLinkCopertina,
          redirect: this.mediaLinkRedirect,
          lang: this.radioGroup,
          theme: this.theme,
        },
      })
        .then((response) => {
          this.$router.go();
          $EventBus.$emit('message', { type: 'success', text: 'Aggiunto media alle istruzioni' });
        })
        .catch((err) => {
          console.log('media get error', err);
          $EventBus.$emit('message', { type: 'error', text: 'Impossibile aggiungere media' });
        });
    },
    tenantContain(text) {
      let find = false;
      for (const id of this.tenantsId) {
        if (id.split('-')[0].toLowerCase() === text.toLowerCase()) find = true;
      }
      return find;
    },
    closeBrowser() {
      this.browseDialog = false;
    },
  },
  computed: {
    filteredHowtolist() {
      return this.howtolist.filter(card => {
        return this.isAdmin || (this.userTheme == card.theme && this.$i18n.locale == card.lang);
      });
    },
    userTheme() {
      return this.$store.state.user.userTheme;
    },
    isAdmin() {
      if (this.$userHasRoles(['admin'])) return true;
      else return false;
    },
    resourceType() {
      return this.type.map((t) => {
        if (t === 'pdf') {
          t = 'raw'; // per cloudinary i pdf sono immagini
        }
        return t;
      });
    },
  },
  watch: {
    selected() {
      if (this.flag === 1) this.mediaLinkCopertina = this.selected[0].public_id;
      else this.mediaLinkRedirect = this.selected[0].url;
      this.closeBrowser();
    },
  },
  mounted() {
    for (const t of this.$user.tenants) {
      this.getTenant(t);
    }
    this.getHowTo();
    if (this.$store.state.user.userTheme == 'drin') {
      this.isDrin = true;
    } else {
      this.isDrin = false;
    }
  },
};
</script>

<style scoped>
.flexcard {
  display: flex;
  flex-direction: column;
  position: relative;
  height: 100%;
}

.flexcard:hover {
  cursor: pointer;
}

.flexcard img {
  max-width: 100%;
}

.flex-val {
  flex: none;
}

.fit-content {
  width: fit-content;
}

.wrapper-flex {
  display: flex;
}
</style>
